import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Form } from "react-bootstrap";
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { InputText } from 'primereact/inputtext';
// Components for Each Section
const BrandIdentity = ({ brandId }) => {
    const { accessToken, role } = useAuth();
    const [brandIdentity, setBrandIdentity] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false); // New state for submit button
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const [showOtherInputs, setShowOtherInputs] = useState({
        brand_personality: false,
        tone_of_voice: false,
    });
    const allowedRoles = [
        'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
        'Social_Media_Manager', 'Task_manager'
    ];
    // Form States
    const [formData, setFormData] = useState({
        brand_personality: [],
        tone_of_voice: [],
        primary_colors: '',
        secondary_colors: '',
        fonts: '',
        typography: '',
        logo_usage_guidelines: ''
    });
    const fetchBrandIdentity = async () => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/BrandBookRoutes/brand-Identity/${brandId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );
            setBrandIdentity(response.data);
            // Populate form data
            setFormData({
                brand_personality: response.data.brand_personality || [],
                tone_of_voice: response.data.tone_of_voice || [],
                primary_colors: response.data.primary_colors || '',
                secondary_colors: response.data.secondary_colors || '',
                fonts: response.data.fonts || '',
                typography: response.data.typography || '',
                logo_usage_guidelines: response.data.logo_usage_guidelines || ''
            });
        } catch (err) {
            console.error("Error fetching brand overview:", err);

        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (brandId) {
            fetchBrandIdentity();
        }
    }, [brandId, accessToken]);

    const handleEdit = () => {
        setEditDialogVisible(true);
    };


    const handleCheckboxChange = (e, category) => {
        const { value, checked } = e.target;

        setFormData((prevData) => {
            let updatedValues;

            if (value === "Other") {
                setShowOtherInputs((prev) => ({
                    ...prev,
                    [category]: checked, // Show input only if "Other" is checked
                }));

                return {
                    ...prevData,
                    [category]: checked
                        ? [...prevData[category], { Other: "" }] // Add "Other" entry
                        : prevData[category].filter((item) => typeof item !== "object"), // Remove "Other"
                };
            }

            updatedValues = checked
                ? [...prevData[category], value]
                : prevData[category].filter((item) => item !== value);

            return {
                ...prevData,
                [category]: updatedValues,
            };
        });
    };



    const handleOtherInputChange = (e, category) => {
        const { value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [category]: prevData[category].map((item) =>
                typeof item === "object" ? { Other: value } : item
            ),
        }));
    };




    const handleBrandIdentityChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };



    const handleSubmit = async () => {
        setSubmitLoading(true);
        try {
            const response = await axios.put(`${config.apiBASEURL}/BrandBookRoutes/brand-Identity/${brandIdentity.brand_identity_id}/${brandId}`, formData, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            if (response.status === 200) {
                setEditDialogVisible(false);
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    fetchBrandIdentity(); // Refresh data after update
                }, 5000);
            }
        } catch (err) {
            console.error("Error updating brand identity:", err);
            setVideocrossDialogVisible(true);
            setTimeout(() => {
                setVideocrossDialogVisible(false);
            }, 5000);
        } finally {
            setSubmitLoading(false);
        }
    };

    useEffect(() => {
        setShowOtherInputs({
            brand_personality: formData.brand_personality.some(el => typeof el === "object"),
            tone_of_voice: formData.tone_of_voice.some(el => typeof el === "object")
        });
    }, [formData]); // Update when formData changes


    if (loading) return <p>Loading...</p>;


    // Function to extract values from array (handling "Other" case)
    const formatArrayData = (data) =>
        data
            .map(item => (typeof item === "string" ? item : item.Other)) // Extracts "Other" key values
            .join(", ");

    return (
        <>
            <Card className="view-card">
                <Card.Header className="h6 border-0 bg-light d-flex justify-content-between align-items-center">
                    <div>
                        Brand Identity
                        <small className="text-danger d-block mt-1" style={{fontSize: '12px'}}>
                            Last Update: {brandIdentity?.updatedAt ? new Date(brandIdentity.updatedAt).toLocaleString('en-GB') : 'N/A'}
                        </small>
                    </div>
                    
                    <div className="d-flex align-items-center">
                        <small className="text-warning ">
                            {allowedRoles.includes(role) && (
                                <Button
                                    title="Edit"
                                    icon="pi pi-pencil"
                                    className="p-0 border-0"
                                    text
                                    severity="help"
                                    onClick={handleEdit}
                                />
                            )}
                        </small>
                    </div>
                </Card.Header>
                <Card.Body className="p-0 pb-2 ">
                    <Table className="brandTable">
                        <tbody>
                            <tr>
                                <th className="text-start">Brand Personality <small className="d-block">(Select any that apply or
                                    add more):</small></th>
                                <td>
                                    {formatArrayData(brandIdentity?.brand_personality)}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Tone of Voice<small className="d-block">(How should the brand sound?):</small></th>
                                <td>
                                    {formatArrayData(brandIdentity?.tone_of_voice)}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Primary:</th>
                                <td>
                                    {brandIdentity?.primary_colors}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Secondary:</th>
                                <td>
                                    {brandIdentity?.secondary_colors}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Fonts:</th>
                                <td>
                                    {brandIdentity?.fonts}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Typography:</th>
                                <td>
                                    {brandIdentity?.typography}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Logo Usage Guidelines:</th>
                                <td>
                                    {brandIdentity?.logo_usage_guidelines}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* Edit Dialog */}
            <Dialog
                header="Edit Brand Identity"
                visible={editDialogVisible}
                style={{ width: '60vw' }}
                onHide={() => setEditDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" icon="pi pi-times" severity="danger" onClick={() => setEditDialogVisible(false)} className="p-button-text py-2" />
                        <Button
                            label={submitLoading ? "Saving..." : "Save"}
                            icon={submitLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            severity="success"
                            onClick={handleSubmit}
                            disabled={submitLoading}
                            autoFocus
                            className="py-2"
                        />
                    </div>
                }
            >
                <Row style={{height: '70vh', overflowY: 'auto'}}>
                    <Col md={6} lg={6} className="mb-4 pe-lg-5 border-end">
                        <Form.Label>Brand Personality <sub>(Select any that apply or add more)</sub></Form.Label>
                        <div className="d-flex flex-wrap gap-4 justify-content-between mt-1 pt-4 border-top">
                            {["Playful", "Professional", "Luxurious", "Minimalist", "Bold", "Quirky", "Traditional"].map((item, index) => (
                                <div key={index} className="d-flex align-items-center fixed_checkbox">
                                    <Checkbox
                                        inputId={`personality-${index}`}
                                        value={item}
                                        onChange={(e) => handleCheckboxChange(e, "brand_personality")}
                                        checked={formData.brand_personality.some(el => el === item)}
                                    />
                                    <label htmlFor={`personality-${index}`} className="ms-2">{item}</label>
                                </div>
                            ))}
                            <div className="d-flex align-items-center fixed_checkbox">
                                <Checkbox
                                    inputId="personality-other"
                                    value="Other"
                                    onChange={(e) => handleCheckboxChange(e, "brand_personality")}
                                    checked={showOtherInputs.brand_personality}
                                />
                                <label htmlFor="personality-other" className="ms-2">Other</label>
                            </div>
                            {showOtherInputs.brand_personality && (
                                <div className="w-100">
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter other"
                                        value={formData.brand_personality.find(el => typeof el === "object")?.Other || ""}
                                        onChange={(e) => handleOtherInputChange(e, "brand_personality")}
                                    />
                                </div>
                            )}
                        </div>
                    </Col>

                    <Col md={6} lg={6} className="mb-4 ps-lg-5">
                        <Form.Label>Tone of Voice  <sub>(How should the brand sound?)</sub></Form.Label>
                        <div className="d-flex flex-wrap gap-4 justify-content-between mt-1 pt-4 border-top">
                            {["Formal", "Friendly", "Authoritative", "Conversational", "Witty", "Inspirational"].map((item, index) => (
                                <div key={index} className="d-flex align-items-center fixed_checkbox">
                                    <Checkbox
                                        inputId={`tone-${index}`}
                                        value={item}
                                        onChange={(e) => handleCheckboxChange(e, "tone_of_voice")}
                                        checked={formData.tone_of_voice.some(el => el === item)}
                                    />
                                    <label htmlFor={`tone-${index}`} className="ms-2">{item}</label>
                                </div>
                            ))}
                            <div className="d-flex align-items-center fixed_checkbox">
                                <Checkbox
                                    inputId="tone-other"
                                    value="Other"
                                    onChange={(e) => handleCheckboxChange(e, "tone_of_voice")}
                                    checked={showOtherInputs.tone_of_voice}
                                />
                                <label htmlFor="tone-other" className="ms-2">Other</label>
                            </div>
                            {showOtherInputs.tone_of_voice && (
                                <div className="w-100">
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter other"
                                        value={formData.tone_of_voice.find(el => typeof el === "object")?.Other || ""}
                                        onChange={(e) => handleOtherInputChange(e, "tone_of_voice")}
                                    />
                                </div>
                            )}
                        </div>
                    </Col>

                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Primary Color</Form.Label>
                        <Form.Control as="textarea" className="h-auto" rows={3} name="primary_colors" value={formData.primary_colors} onChange={handleBrandIdentityChange} />
                    </Col>
                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Secondary Color</Form.Label>
                        <Form.Control as="textarea" className="h-auto" rows={3} name="secondary_colors" value={formData.secondary_colors} onChange={handleBrandIdentityChange} />
                    </Col>
                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Fonts</Form.Label>
                        <Form.Control as="textarea" className="h-auto" rows={3} name="fonts" value={formData.fonts} onChange={handleBrandIdentityChange} />
                    </Col>
                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Typography</Form.Label>
                        <Form.Control as="textarea" className="h-auto" rows={3} name="typography" value={formData.typography} onChange={handleBrandIdentityChange} />
                    </Col>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Logo Usage Guidelines</Form.Label>
                        <Form.Control as="textarea" name="logo_usage_guidelines" rows={5} className="h-auto" value={formData.logo_usage_guidelines} onChange={handleBrandIdentityChange} />
                    </Col>
                </Row>
            </Dialog>





            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};
export default BrandIdentity;